<template>
  <speakol-summary-card>

    <!-- title -->
    <template v-slot:title>
      <div class="title md:title">{{ $t('system_fund.order_summary.title') }}</div>
    </template>

    <!-- body -->
    <template v-slot:body>

      <!-- Available Balance -->
      <div class="flex items-baseline mb-6">
        <div class="w-1/2 amount-label md:amount-label">{{ $t('system_fund.order_summary.available_balance') }}</div>
        <div class="w-1/2 flex justify-end">
          <div class="amount md:amount">{{ balance | addComma('$') }}</div>
        </div>
      </div>


      <!-- Refund amount -->
      <div class="flex items-baseline mb-6">
        <div class="w-1/2 amount-label md:amount-label">{{ $t('system_fund.order_summary.refund_amount') }}</div>
        <div class="w-1/2 flex justify-end">
          <div class="amount md:amount">{{  refund | addComma('$') }}</div>
        </div>
      </div>

      <!-- VAT -->
      <div class="flex items-baseline">
        <div class="w-12 amount-label mr-4 md:amount-label">{{ $t('system_fund.order_summary.vat') }}</div>
        <div class="w-12 percentage md:percentage">{{ `${vatPercentage}%` }}</div>
        <div class="w-full flex justify-end">
          <div class="amount md:amount">{{ renderedVAT | addComma('$') }}</div>
        </div>
      </div>

      <!-- MAX VAT Warning -->
      <div class="notifications-bar items-center border-speakol-color" v-if="errors.has('max_vat')">
        <div class="flex">
          <div class="">
            <vs-icon icon="speakol-info" color="#1890FF" class="l-2" bg="FDF5E1" icon-pack="speakol" round></vs-icon>
          </div>

          <div class="">
            <span class="vat-warning">
              {{errors.first('max_vat')}}
            </span>
          </div>
        </div>

      </div>

    </template>

    <!-- footer -->
    <template v-slot:footer>

      <div class="flex items-baseline mb-2">
        <div class="w-1/2 amount-total-label md:amount-total-label">{{ $t('system_fund.order_summary.remaining') }}</div>
        <div class="w-1/2 flex justify-end">
          <div class="amount-total md:amount-total">{{ total | addComma('$') }}</div>
        </div>
      </div>

    </template>

  </speakol-summary-card>
</template>

<script>
export default {
  props: ['account', 'refund', 'balance', 'maxAvailableVat', 'paymentMethod'],

  data () {
    return {}
  },

  watch: {
    vat (newVal) {
      this.errors.remove('max_vat')

      if (newVal >= this.maxAvailableVat) {
        this.errors.add({
          field: 'max_vat',
          msg: this.$t('system_fund.order_summary.refund_max_vat')
        })
      }
    }
  },

  computed: {
    total () {
      return parseFloat(this.balance || 0) - parseFloat(this.refund || 0)
    },

    vatPercentage () {
      if (this.isEligableForVAT())  {
        return parseFloat(this.account.actual_vat_percentage)
      }

      return 0
    },

    isVatEnabled () {
      return this.isEligableForVAT()
    },

    vat () {
      if (this.isVatEnabled) {
        return  this.refund * this.vatPercentage / 100
      }
      return 0;
    },

    renderedVAT () {
      return (this.maxAvailableVat >= this.vat ? this.vat : this.maxAvailableVat)
    }
  },
  methods: {
    isEligableForVAT () {
      const paymentMehtodsHaveVAT = [
        this.$constants.PAYMENT_METHODS.STRIPE,
        this.$constants.PAYMENT_METHODS.PAYPAL,
        this.$constants.PAYMENT_METHODS.PAYTABS,
        this.$constants.PAYMENT_METHODS.CHECKOUT,
        this.$constants.PAYMENT_METHODS.CASH,
        this.$constants.PAYMENT_METHODS.BANK
      ]
      if (
        this.paymentMethod &&
        this.account &&
        this.account.actual_vat_percentage > 0 &&
        paymentMehtodsHaveVAT.includes(this.paymentMethod)
      ) {
        return true
      }

      return false
    }
  }
}

</script>


<style lang="scss" scoped>
$bgColor: #e6f5fb;
$warningTextColor: #323232;

.notifications-bar {
  padding: 12px 10px;
  background: $bgColor;
  box-sizing: border-box;
  margin-top: 18px;
  border-radius: 4px;
  border: 1px solid;

  .flex {
    align-items: center;

    i {
      margin-right: 9px;
    }
  }

  .vat-warning {
    font-size: 12px;
    margin-bottom: 12px;
    position: relative;
    bottom: 21%;
    color: $warningTextColor;
  }
}

.title {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #2c2c2c;
}

.amount-label {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #2c2c2c;
}

.amount {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #2c2c2c;
}

.amount-total-label {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #2c2c2c;
}

.amount-total {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #2c2c2c;
}

.balance-amount-label {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #2c2c2c;

  @apply whitespace-no-wrap;
}

.balance-amount {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #2c2c2c;
}

.percentage {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 19px;
  color: #0092d7;
}

@media (min-width: 768px) {
  .md\:title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
  }

  .md\:amount-label {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    color: #2c2c2c;
  }

  .md\:amount {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #2c2c2c;
  }

  .md\:amount-total-label {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #2c2c2c;
  }

  .md\:amount-total {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #2c2c2c;
  }

  .md\:balance-amount {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #2c2c2c;
  }

  .md\:percentage {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 19px;
    color: #0092d7;
  }
}
</style>
